import { render } from "./SignatureCapture.vue?vue&type=template&id=1a4eb08d&scoped=true"
import script from "./SignatureCapture.vue?vue&type=script&lang=js"
export * from "./SignatureCapture.vue?vue&type=script&lang=js"

import "./SignatureCapture.vue?vue&type=style&index=0&id=1a4eb08d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a4eb08d"]])

export default __exports__